import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { getGeneralFaqs, selectGeneralFaqs, selectGeneralFaqsIsLoading, selectGeneralFaqsPagination } from '../feature';
import { GetGeneralFaqsDTO } from '../dtos';

export const useGetGeneralFaqs = () => {
  const dispatch = useAppDispatch();
  const faqs = useAppState(selectGeneralFaqs);
  const isLoading = useAppState(selectGeneralFaqsIsLoading);
  const pagination = useAppState(selectGeneralFaqsPagination);

  useEffect(() => {
    dispatch(getGeneralFaqs(new GetGeneralFaqsDTO()));
  }, [dispatch]);

  return { faqs, isLoading, pagination };
};
